import { COURSE_TYPE } from '@/entities/trainings';
import { id } from '@/services/api';
import * as t from 'io-ts';

export const temporaryId = t.string;

export const courseItemCodec = t.type({
  id: t.union([id, temporaryId]),
  type: t.keyof({
    [COURSE_TYPE.SECTION]: null,
    [COURSE_TYPE.TEXT]: null,
    [COURSE_TYPE.VIDEO]: null,
    [COURSE_TYPE.IMAGE]: null,
    [COURSE_TYPE.QUIZ]: null,
  }),
  title: t.string,
  description: t.union([t.string, t.null]),
  position: t.number,
  section_id: t.union([id, temporaryId, t.null]),
});

export const courseSectionCodec = t.intersection([
  courseItemCodec,
  t.type({
    type: t.literal(COURSE_TYPE.SECTION),
    description: t.null,
    section_id: t.null,
    items: t.array(courseItemCodec),
  }),
]);
